"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var injection_js_1 = require("injection-js");
var requestAdapter_1 = require("../../internal/requestAdapter");
var utils_1 = require("../../internal/utils");
var logger_1 = require("../logger/logger");
var tokenManager_1 = require("./tokenManager");
exports.ClientInit = new injection_js_1.InjectionToken("SystemInit");
exports.ClientConfiguration = new injection_js_1.InjectionToken("ClientConfiguration");
var Client = (function () {
    function Client(fetch) {
        this.fetch = fetch;
    }
    Client.prototype.init = function (opts) {
        var _this = this;
        var modules = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            modules[_i - 1] = arguments[_i];
        }
        var systemDefer = utils_1.deferPromise();
        var injector = injection_js_1.ReflectiveInjector.resolveAndCreate([
            {
                provide: exports.ClientInit,
                useValue: systemDefer.promise,
            },
            {
                provide: exports.ClientConfiguration,
                useFactory: function () { return _this.collectConfiguration(modules); },
            },
            {
                provide: tokenManager_1.AuthOptions,
                useValue: opts,
            },
            {
                provide: requestAdapter_1.RequestAdapter,
                useFactory: function () { return new requestAdapter_1.RequestAdapter(_this.fetch); },
            },
            logger_1.Logger,
            tokenManager_1.TokenManager,
        ]);
        this.tokenManager = injector.get(tokenManager_1.TokenManager);
        injector.get(requestAdapter_1.RequestAdapter).provideLogger(injector.get(logger_1.Logger));
        this.modules = modules;
        var parallel = __spreadArrays([
            this.tokenManager.init(opts)
        ], modules.map(function (m) { return m.init(injector); }));
        Promise.all(parallel)
            .then(function () { return _this; })
            .catch(function (err) {
            _this.tokenManager.terminate();
            throw err;
        })
            .then(systemDefer.resolve, systemDefer.reject);
        return systemDefer.promise;
    };
    Client.prototype.terminate = function () {
        var _this = this;
        this.tokenManager.terminate();
        var promises = this.modules.map(function (m) { return m.terminate(); });
        return Promise.all(promises)
            .then(function () { return _this; });
    };
    Client.prototype.collectConfiguration = function (modules) {
        return Object.assign.apply(Object, __spreadArrays([{}], modules.map(function (module) { return module.getConfig(); })));
    };
    return Client;
}());
exports.Client = Client;
